var map = {
	"./Alberto.jpg": 6712,
	"./Anna.jpg": 1035,
	"./Antonio.jpg": 5377,
	"./Baldo.jpg": 4527,
	"./Claudia.jpg": 930,
	"./Fausta.jpg": 1651,
	"./Federica.jpg": 764,
	"./Flavia.jpg": 5572,
	"./Luca.jpg": 4484,
	"./Manuela.jpg": 4766,
	"./Max.jpg": 743,
	"./Nadia.jpg": 9422,
	"./Silvia.jpg": 7361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8830;